module.exports = {
  env: 'production',
  apiUrl: '/api'
}
